import { Edit } from "react-admin";
import { AgreementTabbedForm } from "./AgreementTabbedForm";

export const AgreementEdit = (props) => (
  <Edit title="Criação de Categoria" {...props}>
    <AgreementTabbedForm {...props} />
  </Edit>
);
